import getValue from './getValue';
import isEmptyValue from './isEmptyValue';

function defaultArray(arr) {
  if (!Array.isArray(arr)) {
    return [arr];
  } else if (isEmptyValue(arr)) {
    return [];
  } else {
    return arr;
  }
}

function checkForDuplicates(child, childValue, values) {
  if (values.indexOf(childValue) !== -1) {
    throw new Error(
      `Duplicated value "${String(childValue)}" in <SelectList />`
    );
  }
}

export default function findSelectedAndHighlightedChildren(
  childrenArray,
  selectListValue,
  selectListHighlightValue
) {
  const hasSelectedValue = !isEmptyValue(selectListValue);
  const hasSelectedHighlight = !isEmptyValue(selectListHighlightValue);

  const selectListValues = defaultArray(selectListValue);
  const selectListHighlightValues = defaultArray(selectListHighlightValue);

  return childrenArray.reduce(
    (result, child) => {
      const childValue = getValue(child);

      checkForDuplicates(child, childValue, result.values);

      result.values.push(childValue);

      if (
        (hasSelectedValue && selectListValues.indexOf(childValue) !== -1) ||
        (!hasSelectedValue && child.props.selected)
      ) {
        result.selectedChildren.push(child);
      }

      if (
        (hasSelectedHighlight &&
          selectListHighlightValues.indexOf(childValue) !== -1) ||
        (!hasSelectedHighlight && child.props.highlight)
      ) {
        result.highlightedChildren.push(child);
      }

      return result;
    },
    {
      values: [],
      selectedChildren: [],
      highlightedChildren: [],
    }
  );
}
